export const FRAMEWORKS = {
  "next-app": {
    name: "next-app",
    label: "Next.js",
    links: {
      installation: "https://tiptap.dev/docs/ui-components/install/next",
    },
  },
  "next-pages": {
    name: "next-pages",
    label: "Next.js",
    links: {
      installation: "https://tiptap.dev/docs/ui-components/install/next",
    },
  },
  // remix: {
  //   name: "remix",
  //   label: "Remix",
  //   links: {
  //     installation: "https://tiptap.dev/docs/ui-components/install/remix",
  //   },
  // },
  "react-router": {
    name: "react-router",
    label: "React Router",
    links: {
      installation:
        "https://tiptap.dev/docs/ui-components/install/react-router",
    },
  },
  vite: {
    name: "vite",
    label: "Vite",
    links: {
      installation: "https://tiptap.dev/docs/ui-components/install/vite",
    },
  },
  astro: {
    name: "astro",
    label: "Astro",
    links: {
      installation: "https://tiptap.dev/docs/ui-components/install/astro",
    },
  },
  laravel: {
    name: "laravel",
    label: "Laravel",
    links: {
      installation: "https://tiptap.dev/docs/ui-components/install/laravel",
    },
  },
  "tanstack-start": {
    name: "tanstack-start",
    label: "TanStack Start",
    links: {
      installation: "https://tiptap.dev/docs/ui-components/install/tanstack",
    },
  },
  // gatsby: {
  //   name: "gatsby",
  //   label: "Gatsby",
  //   links: {
  //     installation: "https://tiptap.dev/docs/ui-components/install/gatsby",
  //   },
  // },
  manual: {
    name: "manual",
    label: "Manual",
    links: {
      installation: "https://tiptap.dev/docs/ui-components/install/next",
    },
  },
} as const

export type Framework = (typeof FRAMEWORKS)[keyof typeof FRAMEWORKS]
